import type { ReactNode } from 'react';
import logo from '@/assets/img/logo.png?url';
import beian from '@/assets/img/beian.png?url';
import '@/pages/styles/PublicQuery.css';

interface PublicLayoutProps {
  children: ReactNode;
}

function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="public-query-container">
      {children}

      <div className="copyright">
        <p>
          Copyright © 2026 浙江贝凡网络科技有限公司. All Rights Reserved. |{' '}
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            浙ICP备2025170226号-4
          </a>
        </p>
        <p>
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=33011002018371"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={beian}
              alt="备案图标"
              style={{ height: '20px', marginRight: '5px', verticalAlign: 'middle' }}
            />
            浙公网安备33011002018371号
          </a>
        </p>
      </div>
    </div>
  );
}

export const PublicLogo = () => (
  <div className="query-logo">
    <img src={logo} alt="Logo" style={{ height: '24px' }} />
  </div>
);

export default PublicLayout;
